import React, { useState, useEffect } from "react";
import logo from "../assets/logo-white.png";

const NAV_LINKS = [
  { label: "Integration", href: "#integration" },
  { label: "Services", href: "#services" },
  {label: "Industries", href: "#industries"},
  { label: "Process", href: "#process" },
  { label: "Stack", href: "#stack" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed-top ${scrolled ? "navbar-glass" : ""}`}
      style={{
        borderBottom: scrolled ? "1px solid rgba(7,179,158,0.18)" : "1px solid transparent",
        transition: "background 0.3s ease, border-color 0.3s ease",
      }}
    >
      <nav className="navbar navbar-expand-lg container py-3">
        <a className="navbar-brand d-flex align-items-center" href="#top">
          <img src={logo} alt="GAPNIX Solutions LLP" height="34" />
        </a>
        <button
          className="navbar-toggler border-0"
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label="Toggle navigation"
        >
          <span
            style={{
              display: "block",
              width: 24,
              height: 2,
              background: "#fff",
              marginBottom: 5,
              borderRadius: 2,
            }}
          />
          <span style={{ display: "block", width: 24, height: 2, background: "#fff", marginBottom: 5, borderRadius: 2 }} />
          <span style={{ display: "block", width: 24, height: 2, background: "#fff", borderRadius: 2 }} />
        </button>
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
            {NAV_LINKS.map((link) => (
              <li className="nav-item" key={link.href}>
                <a
                  className="nav-link nav-pill mono-label"
                  style={{ color: "#fff", opacity: 0.85 }}
                  href={link.href}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="nav-item mt-3 mt-lg-0 ms-lg-2">
              <a href="#contact" className="btn-brand d-inline-block text-decoration-none" style={{ fontSize: "0.82rem" }}>
                Start a project
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
